import { Media } from "../dtos/guest";
import { fakeDelay } from "./fakeApi";

/** Stands in for a Bunny upload: returns a placeholder URL instead of uploading the file. */
export async function fakeUploadedMedia(file: File): Promise<Media> {
    await fakeDelay(500);
    return {
        resolutions: [{
            mime_type: file.type,
            name: 'fake',
            aspect_ratio: '1',
            url: `fake://${file.name}`,
            primary: true,
        }],
    };
}
